export default "__VITE_ASSET__8aebcd6e__"